import PostTask from "@/views/Post/PostTask";
import PostTaskDetail from "@/views/Post/PostTaskDetail";

export default [
  {
    path: "post",
    name: "Post",
    component: { render: h => h("router-view") },
    meta: {
      nav: {
        icon: "el-icon-s-claim",
        title: "岗位建设"
      },
      breadcrumb: {
        title: "岗位建设",
        replace: false
      }
    },
    children: [
      {
        path: "task",
        name: "PostTask",
        redirect: { name: "PostTaskSelf" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "PostTaskSelf",
            component: PostTask,
            permission: "kcell.api.jiker.fuwu_admin.skill_model_tasks.index",
            meta: {
              title: "极客-岗位建设-岗位标准",
              nav: {
                title: "岗位标准"
              },
              breadcrumb: {
                title: "岗位标准",
                replace: false
              }
            }
          },
          {
            path: ":id",
            name: "PostTaskDetail",
            component: PostTaskDetail,
            permission: "kcell.api.jiker.fuwu_admin.skill_model_tasks.update",
            meta: {
              title: "极客-岗位建设-岗位标准"
            }
          }
        ]
      }
    ]
  }
];
